// NEOIQ-2427 — Super Agent "Top-up for Agent" (agent-to-agent transfer)
// Shapes below are transcribed from the backend contract confirmed in the ticket thread for
// POST /nfront/v1/proxy/accounts:transferToAgent.

// Minimal display info for the currently logged-in agent (the sender), threaded through the
// select-recipient → enter-amount → confirm-transfer → enter-passcode → transfer-result chain so
// each screen can render the Sender card the same way the Figma design does (name + mobile),
// instead of falling back to a raw account/user id.
export interface ISenderInfo {
    name: string;
    mobile: string;
}

export interface ITransferToAgentRequest {
    mobile_number: string;
    amount: number;
    currency: string;
    note?: string;
}

export interface IAccountTransferTransaction {
    transaction_id: string;
    sender_account_id: string;
    recipient_account_id: string;
    amount: number;
    currency: string;
    fee_amount: number;
    notes?: string;
    created: string;
}

// detail values the backend returns for this endpoint — switch on these for user-facing copy.
export enum ETransferToAgentErrorDetail {
    InitiatorNotSuperAgent = 'accounts.transfer.initiator_not_super_agent',
    RecipientMustBeAgent = 'accounts.transfer.recipient_must_be_agent',
    RecipientNotActive = 'accounts.transfer.recipient_not_active',
    SameAccountNotAllowed = 'accounts.transfer.same_account_not_allowed',
}
